document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.newsletter-popup-banner')
    .forEach(function (section) {
      var popup = section.querySelector('[data-newsletter-popup]');
      var openButton = section.querySelector('[data-newsletter-open]');
      var closeButtons = section.querySelectorAll(
        '[data-newsletter-close]'
      );
      var form = section.querySelector('.newsletter-form');
      var emailInput = section.querySelector(
        '.newsletter-popup__email'
      );
      var errorMessage = section.querySelector(
        '[data-newsletter-error]'
      );

      if (!popup || !openButton) return;

      function openPopup() {
        popup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }

      function closePopup() {
        popup.classList.remove('is-active');
        document.body.style.overflow = '';
      }

      function showEmailError(message) {
        if (!emailInput || !errorMessage) return;

        errorMessage.textContent = message;
        errorMessage.hidden = false;

        emailInput.classList.add('has-error');
        emailInput.setAttribute('aria-invalid', 'true');
      }

      function clearEmailError() {
        if (!emailInput || !errorMessage) return;

        errorMessage.textContent = '';
        errorMessage.hidden = true;

        emailInput.classList.remove('has-error');
        emailInput.setAttribute('aria-invalid', 'false');
      }

      function validateEmail() {
        if (!emailInput) return true;

        var email = emailInput.value.trim();

        /*
         * Requires:
         * - text before @
         * - a domain after @
         * - a domain extension containing at least two letters
         */
        var validEmailPattern =
          /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

        if (email === '') {
          showEmailError('Please enter your email address.');
          return false;
        }

        if (!validEmailPattern.test(email)) {
          showEmailError(
            'Please enter a valid email address.'
          );
          return false;
        }

        clearEmailError();
        return true;
      }

      openButton.addEventListener('click', function () {
        openPopup();
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          closePopup();
        });
      });

      if (emailInput) {
        /*
         * Prevent inconsistent native mobile validation messages.
         * Our inline message is shown instead.
         */
        emailInput.addEventListener('invalid', function (event) {
          event.preventDefault();

          validateEmail();
          openPopup();
          emailInput.focus();
        });

        emailInput.addEventListener('input', function () {
          var email = emailInput.value.trim();
          var validEmailPattern =
            /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

          if (validEmailPattern.test(email)) {
            clearEmailError();
          }
        });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          if (!validateEmail()) {
            event.preventDefault();
            event.stopPropagation();

            openPopup();
            emailInput.focus();

            return false;
          }
        });
      }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  if (
    !document.documentElement.classList.contains(
      'newsletter-success'
    )
  ) {
    return;
  }

  var popup = document.querySelector(
    '[data-newsletter-popup]'
  );

  if (popup) {
    popup.classList.remove('is-active');
  }

  document.body.style.overflow = '';

  var successMessage = document.querySelector(
    '.newsletter-banner-success'
  );

  if (successMessage) {
    successMessage.style.display = 'block';

    setTimeout(function () {
      successMessage.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 200);
  }
});